module.exports = __webpack_public_path__ + "img/bagels_serving_suggestion.013a4f84.jpg";